<template>
  <div>
    <b-form-group label="CAPTCHA" label-for="captcha-input">
      <img :src="captchaImage" alt="CAPTCHA" />
      <b-form-input
        class="mt-3"
        id="captcha-input"
        v-model="captchaText"
        placeholder="Enter CAPTCHA"
      ></b-form-input>
    </b-form-group>
  </div>
</template>

<script>
export default {
  props: {
    result: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      captchaText: "",
    };
  },
  computed: {
    captchaImage() {
      return `data:image/png;base64,${this.result}`;
    },
  },
  watch: {
    captchaText(newVal) {
      this.$emit("update-captcha-text", newVal);
    },
  },
};
</script>
